interface Props {
  cancelUrl?: string;
}

export function Expired({ cancelUrl }: Props) {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-sm border border-gray-100 p-8 text-center">
        <div className="flex items-center justify-center w-16 h-16 bg-amber-50 rounded-full mx-auto mb-6">
          <svg className="w-8 h-8 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>

        <h2 className="text-xl font-bold text-gray-900 mb-2">Sesión expirada</h2>
        <p className="text-gray-500 mb-6">
          Esta sesión de pago ha expirado. Por favor regresa a la tienda para iniciar un nuevo proceso.
        </p>

        {cancelUrl && (
          <a
            href={cancelUrl}
            className="block w-full bg-gray-800 text-white font-semibold py-3 px-6 rounded-xl hover:bg-gray-900 transition-colors text-center"
          >
            Volver a la tienda
          </a>
        )}
      </div>
    </div>
  );
}
